import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "shouldFitContainer", "shouldRenderToParent"];
import React from 'react';
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */
var CustomPopupContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ = _ref.shouldFitContainer,
    __ = _ref.shouldRenderToParent,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref
  }), children);
});
export default CustomPopupContainer;